module.exports = __webpack_public_path__ + "f9036a401bdaadd541627409333c399f.pdf";